export const profileConst = {
    SUCCESS: 'USER_PROFILE_SUCCESS',
    FAILURE: 'USER_PROFILE_FAILURE',
    CLOSE: 'USER_PROFILE_CLOSE'
};
